/**
 * Formats a date range in a human-readable format (e.g., "Jan 5–7" or "Jan 30–Feb 1")
 * @param from - Start date in YYYY-MM-DD format
 * @param to - End date in YYYY-MM-DD format
 * @returns Formatted date range string
 */
export const formatDateRange = (from: string, to: string): string => {
  const fromDate = new Date(`${from}T00:00:00Z`);
  const toDate = new Date(`${to}T00:00:00Z`);

  const monthFormatter = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    timeZone: 'UTC',
  });
  const fromMonth = monthFormatter.format(fromDate);
  const toMonth = monthFormatter.format(toDate);
  const fromDay = fromDate.getUTCDate();
  const toDay = toDate.getUTCDate();

  if (fromMonth === toMonth) {
    return `${fromMonth} ${fromDay}–${toDay}`;
  }
  return `${fromMonth} ${fromDay}–${toMonth} ${toDay}`;
};
